export default "__VITE_PUBLIC_ASSET__a4148b4c__"